import {ComponentType, lazy, LazyExoticComponent} from 'react'

const RELOAD_FLAG = 'chunk-reload'

const readFlag = (): boolean => {
  try {
    return window.sessionStorage.getItem(RELOAD_FLAG) === 'true'
  } catch {
    return true
  }
}

const writeFlag = (value: boolean) => {
  try {
    if (value) window.sessionStorage.setItem(RELOAD_FLAG, 'true')
    else window.sessionStorage.removeItem(RELOAD_FLAG)
  } catch {}
}

export const lazyWithRetry = <T extends ComponentType<any>>(
  factory: () => Promise<{default: T}>
): LazyExoticComponent<T> =>
  lazy(async () => {
    try {
      const module = await factory()
      writeFlag(false)
      return module
    } catch (e) {
      if (readFlag()) throw e

      writeFlag(true)
      window.location.reload()
      return new Promise<{default: T}>(() => {})
    }
  })
